export function getPaymentDates(intervals: number[]): string[] {
  const today = new Date();

  return intervals.map((days) =>
    new Date(today.getTime() + days * 24 * 60 * 60 * 1000).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
    }),
  );
}
